/* eslint-disable */
import React, { Component } from 'react'
import { Overlay } from './styles'

class ClickOut extends Component {
  componentDidMount() {
    this.el.addEventListener('click', this.onSelfClick)
    document.addEventListener('click', this.onAnyClick)
  }

  componentWillUnmount() {
    this.el.removeEventListener('click', this.onSelfClick)
    document.removeEventListener('click', this.onAnyClick)
  }

  onSelfClick = e => {
    e.clickOutTarget = this.el
  }

  onAnyClick = e => {
    const { el, props: { callback } } = this

    if (e.clickOutTarget !== el) {
      callback(e)
    }
  }

  render() {
    return (
      <div
        ref={el => {
          this.el = el
        }}
      >
        {this.props.children}
      </div>
    )
  }
}

export default ClickOut

export const OverlayClick = ({ isOpen, onClick }) => <Overlay isOpen={isOpen} onClick={onClick} />



// WEBPACK FOOTER //
// ./src/app/elements/ClickOut/index.js